onLoad(($) => {
  $(document).ready(function () {
    var tables = $('#dt_statement');

    new DataTable(tables, {
      bStateSave: true,
      bRestore: true,
      info: false,
      searching: true,
      paging: true, 

      language: {
        search: '',
        searchPlaceholder: 'Digite para buscar...',
        lengthMenu: 'Mostrar _MENU_ registros',
        perPage: 'Itens',
        entriesPerPage: 'Itens por pagina',
        zeroRecords: 'Nenhum registro encontrado',
        infoEmpty: 'Sem informações disponíveis',
        infoFiltered: '(filtrado de _MAX_ registros totais)',
        paginate: {
          first: 'Primeiro',
          last: 'Último',
          next: 'Próximo',
          previous: 'Anterior'
        },
        
      },
    });
  });
});